"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsControllerListV1TabEnum = exports.NotificationsApi = void 0;
var runtime = __importStar(require("../runtime"));
var AdminAnnouncementHistoryItemDto_1 = require("../models/AdminAnnouncementHistoryItemDto");
var AdminAnnouncementRequestDto_1 = require("../models/AdminAnnouncementRequestDto");
var AdminAnnouncementResponseDto_1 = require("../models/AdminAnnouncementResponseDto");
var DeviceTokenAckDto_1 = require("../models/DeviceTokenAckDto");
var ListNotificationsResponseDto_1 = require("../models/ListNotificationsResponseDto");
var MarkAllReadResponseDto_1 = require("../models/MarkAllReadResponseDto");
var NotificationCountsDto_1 = require("../models/NotificationCountsDto");
var NotificationDto_1 = require("../models/NotificationDto");
var NotificationResponseDto_1 = require("../models/NotificationResponseDto");
var RegisterDeviceAckDto_1 = require("../models/RegisterDeviceAckDto");
var RegisterDeviceTokenDto_1 = require("../models/RegisterDeviceTokenDto");
var TopicBroadcastRequestDto_1 = require("../models/TopicBroadcastRequestDto");
var TopicBroadcastResponseDto_1 = require("../models/TopicBroadcastResponseDto");
var TopicSubscriptionAckDto_1 = require("../models/TopicSubscriptionAckDto");
var UnreadCountResponseDto_1 = require("../models/UnreadCountResponseDto");
/**
 *
 */
var NotificationsApi = /** @class */ (function (_super) {
    __extends(NotificationsApi, _super);
    function NotificationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates request options for notificationsControllerAdminAnnouncementV1 without sending the request
     */
    NotificationsApi.prototype.notificationsControllerAdminAnnouncementV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['adminAnnouncementRequestDto'] == null) {
                            throw new runtime.RequiredError('adminAnnouncementRequestDto', 'Required parameter "adminAnnouncementRequestDto" was null or undefined when calling notificationsControllerAdminAnnouncementV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/notifications/admin/announcement";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, AdminAnnouncementRequestDto_1.AdminAnnouncementRequestDtoToJSON)(requestParameters['adminAnnouncementRequestDto']),
                            }];
                }
            });
        });
    };
    /**
     * Sends a single FCM push to the shared `announcement` topic and writes one in-app Notification Center row per active user. Every device auto-subscribes to that topic on `POST /devices` so the push is one FCM call, not a second per-token send. Pass `dedupeKey` as an idempotency key — repeat submissions with the same key return the same `broadcastId` and do not re-send or duplicate inbox rows.
     * Admin — broadcast an announcement to every user
     */
    NotificationsApi.prototype.notificationsControllerAdminAnnouncementV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerAdminAnnouncementV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, AdminAnnouncementResponseDto_1.AdminAnnouncementResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Sends a single FCM push to the shared `announcement` topic and writes one in-app Notification Center row per active user. Every device auto-subscribes to that topic on `POST /devices` so the push is one FCM call, not a second per-token send. Pass `dedupeKey` as an idempotency key — repeat submissions with the same key return the same `broadcastId` and do not re-send or duplicate inbox rows.
     * Admin — broadcast an announcement to every user
     */
    NotificationsApi.prototype.notificationsControllerAdminAnnouncementV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerAdminAnnouncementV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for notificationsControllerAdminTopicBroadcastV1 without sending the request
     */
    NotificationsApi.prototype.notificationsControllerAdminTopicBroadcastV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['topicBroadcastRequestDto'] == null) {
                            throw new runtime.RequiredError('topicBroadcastRequestDto', 'Required parameter "topicBroadcastRequestDto" was null or undefined when calling notificationsControllerAdminTopicBroadcastV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/notifications/admin/topic-broadcast";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, TopicBroadcastRequestDto_1.TopicBroadcastRequestDtoToJSON)(requestParameters['topicBroadcastRequestDto']),
                            }];
                }
            });
        });
    };
    /**
     * Sends a push to every FCM subscriber of `topic`. **No per-user rows are created** — recipients are opaque. Set `campaignId` to make the send idempotent: repeat submissions of the same `(topic, campaignId)` return the existing broadcast id and do not re-send.
     * Admin — enqueue an FCM topic broadcast
     */
    NotificationsApi.prototype.notificationsControllerAdminTopicBroadcastV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerAdminTopicBroadcastV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, TopicBroadcastResponseDto_1.TopicBroadcastResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Sends a push to every FCM subscriber of `topic`. **No per-user rows are created** — recipients are opaque. Set `campaignId` to make the send idempotent: repeat submissions of the same `(topic, campaignId)` return the existing broadcast id and do not re-send.
     * Admin — enqueue an FCM topic broadcast
     */
    NotificationsApi.prototype.notificationsControllerAdminTopicBroadcastV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerAdminTopicBroadcastV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for notificationsControllerCountsV1 without sending the request
     */
    NotificationsApi.prototype.notificationsControllerCountsV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/notifications/counts";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Powers both tab badges in one request. Client empty-state rule: `all === 0` → \"No Notifications Yet\"; `all > 0 && unread === 0` on the unread tab → \"All Caught Up\".
     * Feed counts { all, unread }
     */
    NotificationsApi.prototype.notificationsControllerCountsV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerCountsV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, NotificationCountsDto_1.NotificationCountsDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Powers both tab badges in one request. Client empty-state rule: `all === 0` → \"No Notifications Yet\"; `all > 0 && unread === 0` on the unread tab → \"All Caught Up\".
     * Feed counts { all, unread }
     */
    NotificationsApi.prototype.notificationsControllerCountsV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerCountsV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for notificationsControllerDeactivateDeviceV1 without sending the request
     */
    NotificationsApi.prototype.notificationsControllerDeactivateDeviceV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['token'] == null) {
                            throw new runtime.RequiredError('token', 'Required parameter "token" was null or undefined when calling notificationsControllerDeactivateDeviceV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/notifications/devices/{token}";
                        urlPath = urlPath.replace('{token}', encodeURIComponent(String(requestParameters['token'])));
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Owner-scoped — the caller must own the token or the request returns 404. Sets `is_active = false` and records `invalidation_reason = user_requested`.
     * Deactivate a device token
     */
    NotificationsApi.prototype.notificationsControllerDeactivateDeviceV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerDeactivateDeviceV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, DeviceTokenAckDto_1.DeviceTokenAckDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Owner-scoped — the caller must own the token or the request returns 404. Sets `is_active = false` and records `invalidation_reason = user_requested`.
     * Deactivate a device token
     */
    NotificationsApi.prototype.notificationsControllerDeactivateDeviceV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerDeactivateDeviceV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for notificationsControllerLegacyListV1 without sending the request
     * @deprecated
     */
    NotificationsApi.prototype.notificationsControllerLegacyListV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['pageSize'] != null) {
                            queryParameters['pageSize'] = requestParameters['pageSize'];
                        }
                        if (requestParameters['page'] != null) {
                            queryParameters['page'] = requestParameters['page'];
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/notifications/legacy";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Offset-based pagination. **Do not use for new clients** — prefer `GET /` with cursor pagination. Kept in place until existing mobile clients are updated.
     * Legacy paginated list (deprecated)
     * @deprecated
     */
    NotificationsApi.prototype.notificationsControllerLegacyListV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerLegacyListV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Offset-based pagination. **Do not use for new clients** — prefer `GET /` with cursor pagination. Kept in place until existing mobile clients are updated.
     * Legacy paginated list (deprecated)
     * @deprecated
     */
    NotificationsApi.prototype.notificationsControllerLegacyListV1 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerLegacyListV1Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for notificationsControllerListAdminAnnouncementsV1 without sending the request
     */
    NotificationsApi.prototype.notificationsControllerListAdminAnnouncementsV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['page'] != null) {
                            queryParameters['page'] = requestParameters['page'];
                        }
                        if (requestParameters['limit'] != null) {
                            queryParameters['limit'] = requestParameters['limit'];
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/notifications/admin/announcements";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Offset-paginated history of `topic_broadcasts` rows for the shared `announcement` topic, newest first. Used by the admin Announcement history table.
     * Admin — list past announcement broadcasts
     */
    NotificationsApi.prototype.notificationsControllerListAdminAnnouncementsV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerListAdminAnnouncementsV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(AdminAnnouncementHistoryItemDto_1.AdminAnnouncementHistoryItemDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Offset-paginated history of `topic_broadcasts` rows for the shared `announcement` topic, newest first. Used by the admin Announcement history table.
     * Admin — list past announcement broadcasts
     */
    NotificationsApi.prototype.notificationsControllerListAdminAnnouncementsV1 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            var response;
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerListAdminAnnouncementsV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for notificationsControllerListV1 without sending the request
     */
    NotificationsApi.prototype.notificationsControllerListV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['tab'] != null) {
                            queryParameters['tab'] = requestParameters['tab'];
                        }
                        if (requestParameters['limit'] != null) {
                            queryParameters['limit'] = requestParameters['limit'];
                        }
                        if (requestParameters['cursor'] != null) {
                            queryParameters['cursor'] = requestParameters['cursor'];
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/notifications";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Returns the caller\'s notification feed newest-first. Rows with `metadata.shielded = true` and no `revealed_at` have their `title` / `body` replaced by a masked template — call `POST /:id/reveal` to unmask. Use the returned `nextCursor` (opaque base64url) to fetch the next page.
     * List notifications (cursor-paginated)
     */
    NotificationsApi.prototype.notificationsControllerListV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerListV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, ListNotificationsResponseDto_1.ListNotificationsResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the caller\'s notification feed newest-first. Rows with `metadata.shielded = true` and no `revealed_at` have their `title` / `body` replaced by a masked template — call `POST /:id/reveal` to unmask. Use the returned `nextCursor` (opaque base64url) to fetch the next page.
     * List notifications (cursor-paginated)
     */
    NotificationsApi.prototype.notificationsControllerListV1 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            var response;
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerListV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for notificationsControllerMarkReadV1 without sending the request
     */
    NotificationsApi.prototype.notificationsControllerMarkReadV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling notificationsControllerMarkReadV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/notifications/{id}/read";
                        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Idempotent — re-reading an already-read notification returns the existing `readAt`. Returns 404 (not 403) if the notification belongs to another user, to avoid leaking existence.
     * Mark a notification as read
     */
    NotificationsApi.prototype.notificationsControllerMarkReadV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerMarkReadV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, NotificationResponseDto_1.NotificationResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Idempotent — re-reading an already-read notification returns the existing `readAt`. Returns 404 (not 403) if the notification belongs to another user, to avoid leaking existence.
     * Mark a notification as read
     */
    NotificationsApi.prototype.notificationsControllerMarkReadV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerMarkReadV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for notificationsControllerReadAllV1 without sending the request
     */
    NotificationsApi.prototype.notificationsControllerReadAllV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/notifications/read-all";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Single transactional UPDATE against `is_read = false` rows for the caller. Returns the number of rows affected (may be 0).
     * Mark every unread notification as read
     */
    NotificationsApi.prototype.notificationsControllerReadAllV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerReadAllV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, MarkAllReadResponseDto_1.MarkAllReadResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Single transactional UPDATE against `is_read = false` rows for the caller. Returns the number of rows affected (may be 0).
     * Mark every unread notification as read
     */
    NotificationsApi.prototype.notificationsControllerReadAllV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerReadAllV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for notificationsControllerRegisterDeviceV1 without sending the request
     */
    NotificationsApi.prototype.notificationsControllerRegisterDeviceV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['registerDeviceTokenDto'] == null) {
                            throw new runtime.RequiredError('registerDeviceTokenDto', 'Required parameter "registerDeviceTokenDto" was null or undefined when calling notificationsControllerRegisterDeviceV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/notifications/devices";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, RegisterDeviceTokenDto_1.RegisterDeviceTokenDtoToJSON)(requestParameters['registerDeviceTokenDto']),
                            }];
                }
            });
        });
    };
    /**
     * Upserts on `token`. Called by the mobile client on login and on FCM token refresh. Idempotent — repeat calls re-activate a previously deactivated token.
     * Register / refresh an FCM device token
     */
    NotificationsApi.prototype.notificationsControllerRegisterDeviceV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerRegisterDeviceV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, RegisterDeviceAckDto_1.RegisterDeviceAckDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Upserts on `token`. Called by the mobile client on login and on FCM token refresh. Idempotent — repeat calls re-activate a previously deactivated token.
     * Register / refresh an FCM device token
     */
    NotificationsApi.prototype.notificationsControllerRegisterDeviceV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerRegisterDeviceV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for notificationsControllerRevealV1 without sending the request
     */
    NotificationsApi.prototype.notificationsControllerRevealV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling notificationsControllerRevealV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/notifications/{id}/reveal";
                        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Sets `metadata.revealed_at`, unmasks the row\'s `title` / `body`, and marks the row as read. Only rows with `metadata.shielded === true` are eligible — others return 400 `NOTIFICATION_NOT_SHIELDED`.
     * Reveal a shielded notification
     */
    NotificationsApi.prototype.notificationsControllerRevealV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerRevealV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, NotificationDto_1.NotificationDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Sets `metadata.revealed_at`, unmasks the row\'s `title` / `body`, and marks the row as read. Only rows with `metadata.shielded === true` are eligible — others return 400 `NOTIFICATION_NOT_SHIELDED`.
     * Reveal a shielded notification
     */
    NotificationsApi.prototype.notificationsControllerRevealV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerRevealV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for notificationsControllerSubscribeTopicV1 without sending the request
     */
    NotificationsApi.prototype.notificationsControllerSubscribeTopicV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['token'] == null) {
                            throw new runtime.RequiredError('token', 'Required parameter "token" was null or undefined when calling notificationsControllerSubscribeTopicV1().');
                        }
                        if (requestParameters['topic'] == null) {
                            throw new runtime.RequiredError('topic', 'Required parameter "topic" was null or undefined when calling notificationsControllerSubscribeTopicV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/notifications/devices/{token}/subscribe/{topic}";
                        urlPath = urlPath.replace('{token}', encodeURIComponent(String(requestParameters['token'])));
                        urlPath = urlPath.replace('{topic}', encodeURIComponent(String(requestParameters['topic'])));
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Ownership-scoped. Topic must be 3-64 chars of [a-z0-9:_-] (e.g. sport:cricket). Delegates to FcmProvider.subscribeToTopic; idempotent.
     * Subscribe a device token to an FCM topic
     */
    NotificationsApi.prototype.notificationsControllerSubscribeTopicV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerSubscribeTopicV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, TopicSubscriptionAckDto_1.TopicSubscriptionAckDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Ownership-scoped. Topic must be 3-64 chars of [a-z0-9:_-] (e.g. sport:cricket). Delegates to FcmProvider.subscribeToTopic; idempotent.
     * Subscribe a device token to an FCM topic
     */
    NotificationsApi.prototype.notificationsControllerSubscribeTopicV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerSubscribeTopicV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for notificationsControllerUnreadCountV1 without sending the request
     */
    NotificationsApi.prototype.notificationsControllerUnreadCountV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/notifications/unread-count";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Kept for existing mobile clients. New callers should use `GET /counts`.
     * Unread count only (legacy)
     */
    NotificationsApi.prototype.notificationsControllerUnreadCountV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerUnreadCountV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, UnreadCountResponseDto_1.UnreadCountResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Kept for existing mobile clients. New callers should use `GET /counts`.
     * Unread count only (legacy)
     */
    NotificationsApi.prototype.notificationsControllerUnreadCountV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerUnreadCountV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for notificationsControllerUnsubscribeTopicV1 without sending the request
     */
    NotificationsApi.prototype.notificationsControllerUnsubscribeTopicV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['token'] == null) {
                            throw new runtime.RequiredError('token', 'Required parameter "token" was null or undefined when calling notificationsControllerUnsubscribeTopicV1().');
                        }
                        if (requestParameters['topic'] == null) {
                            throw new runtime.RequiredError('topic', 'Required parameter "topic" was null or undefined when calling notificationsControllerUnsubscribeTopicV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/notifications/devices/{token}/subscribe/{topic}";
                        urlPath = urlPath.replace('{token}', encodeURIComponent(String(requestParameters['token'])));
                        urlPath = urlPath.replace('{topic}', encodeURIComponent(String(requestParameters['topic'])));
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Ownership-scoped. Delegates to `FcmProvider.unsubscribeFromTopic`; idempotent.
     * Unsubscribe a device token from an FCM topic
     */
    NotificationsApi.prototype.notificationsControllerUnsubscribeTopicV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerUnsubscribeTopicV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, TopicSubscriptionAckDto_1.TopicSubscriptionAckDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Ownership-scoped. Delegates to `FcmProvider.unsubscribeFromTopic`; idempotent.
     * Unsubscribe a device token from an FCM topic
     */
    NotificationsApi.prototype.notificationsControllerUnsubscribeTopicV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationsControllerUnsubscribeTopicV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return NotificationsApi;
}(runtime.BaseAPI));
exports.NotificationsApi = NotificationsApi;
/**
 * @export
 */
exports.NotificationsControllerListV1TabEnum = {
    All: 'all',
    Unread: 'unread'
};
